
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"17","cy":"17","r":"14.432","fill":"#8768E2"}}),_c('circle',{attrs:{"cx":"17","cy":"17","r":"12.026","fill":"#8768E2"}}),_c('circle',{attrs:{"cx":"17.001","cy":"17","r":"12.026","transform":"rotate(-34.01 17 17)","fill":"#C0ABFF"}}),_c('path',{attrs:{"d":"M28.215 12.655a12.026 12.026 0 00-4.085-5.341L17 16.999l11.215-4.344zM25.034 25.95a12.027 12.027 0 003.549-5.712L17 17l8.034 8.95zM11.814 27.851a12.027 12.027 0 006.635 1.088L17 17l-5.185 10.851z","fill":"#8768E2"}}),_c('path',{attrs:{"d":"M5.215 14.61a12.026 12.026 0 00.559 6.7L17.002 17 5.215 14.61z","fill":"#8768E2"}}),_c('path',{attrs:{"d":"M16.237 4.998a12.026 12.026 0 00-6.324 2.285L17 17l-.763-12.002z","fill":"#8768E2"}}),_c('path',{attrs:{"d":"M17 21.608a4.608 4.608 0 100-9.216 4.608 4.608 0 000 9.216z","fill":"#8768E2","stroke":"#fff","stroke-width":"2"}})])
          )
        }
      }
    